import React from 'react';
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, FormHelperText } from '@mui/material';
import { roomOptions, wardOptions } from '../constants/options';

const PatientInfoSection = ({ patientData, setPatientData, errors, handlePatientChange, handleBlur }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Patient Name"
          name="patient_name"
          value={patientData.patient_name || ''}
          InputProps={{ readOnly: true }}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="UHID No."
          name="uhid_no"
          value={patientData.uhid_no || ''}
          InputProps={{ readOnly: true }}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="IP No."
          name="ip_no"
          value={patientData.ip_no || ''}
          InputProps={{ readOnly: true }}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Date"
          name="assessment_date"
          type="date"
          value={patientData.assessment_date || ''}
          onChange={handlePatientChange}
          onBlur={handleBlur}
          required
          error={!!errors.assessment_date}
          helperText={errors.assessment_date}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: new Date().toISOString().slice(0, 10) }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required error={!!errors.room_no}>
          <InputLabel>Room No.</InputLabel>
          <Select
            name="room_no"
            value={patientData.room_no || ''}
            onChange={handlePatientChange}
            onBlur={handleBlur}
            label="Room No."
          >
            {roomOptions.map((room) => (
              <MenuItem key={room} value={room}>{room}</MenuItem>
            ))}
          </Select>
          {errors.room_no && <FormHelperText>{errors.room_no}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          select
          fullWidth
          label="Gender"
          name="sex"
          value={patientData.sex || ''}
          InputProps={{ readOnly: true }}
        >
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControl fullWidth required error={!!errors.ward_no}>
          <InputLabel>Ward No.</InputLabel>
          <Select
            name="ward_no"
            value={patientData.ward_no || ''}
            onChange={handlePatientChange}
            onBlur={handleBlur}
            label="Ward No."
          >
            {wardOptions.map((ward) => (
              <MenuItem key={ward} value={ward}>{ward}</MenuItem>
            ))}
          </Select>
          {errors.ward_no && <FormHelperText>{errors.ward_no}</FormHelperText>}
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default PatientInfoSection;
